export const initJobDetailVideo = () => {
  const containers = document.querySelectorAll('.job-image-video');
  containers.forEach((container) => {
    const video = container.querySelector('video');
    const button = container.querySelector('.job-video-button');
    if (!video || !button) return;

    const setState = (isPlaying) => {
      container.classList.toggle('is-playing', isPlaying);
      button.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
    };

    setState(false);

    button.addEventListener('click', () => {
      video.muted = false;
      video.play().catch(() => { });
    });

    video.addEventListener('play', () => setState(true));
    video.addEventListener('pause', () => setState(false));
    video.addEventListener('ended', () => {
      video.currentTime = 0;
      setState(false);
    });
  });
};

export const initJobMenuModal = () => {
  const jobMenuButtons = document.querySelectorAll('.job-detail-menu-btn');
  if (!jobMenuButtons.length) return;

  const fallbackCopyText = (text) => {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.top = '-9999px';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    let copied = false;
    try {
      copied = document.execCommand('copy');
    } catch {
      copied = false;
    }

    document.body.removeChild(textarea);
    return copied;
  };

  const copyText = async (text) => {
    if (navigator.clipboard?.writeText && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch {
        // Fall back to legacy copy in case of permission/availability issues.
      }
    }
    return fallbackCopyText(text);
  };

  const showCopyToast = (message, closeLabel) => {
    let toast = document.getElementById('copyToast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'copyToast';
      toast.className = 'copy-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML = `
        <div class="copy-toast-content">
          <span class="copy-toast-text"></span>
          <button class="copy-toast-close" type="button">✕</button>
        </div>
      `;
      document.body.appendChild(toast);
    }

    const textEl = toast.querySelector('.copy-toast-text');
    if (textEl) {
      textEl.textContent = message || 'Job link copied!';
    }

    const hide = () => {
      toast.classList.remove('is-visible');
    };

    const closeBtn = toast.querySelector('.copy-toast-close');
    if (closeBtn) {
      closeBtn.setAttribute('aria-label', closeLabel || 'Close');
    }
    if (closeBtn && closeBtn.dataset.bound !== 'true') {
      closeBtn.dataset.bound = 'true';
      closeBtn.addEventListener('click', hide);
    }

    if (toast.dataset.timer) {
      window.clearTimeout(Number(toast.dataset.timer));
    }

    toast.classList.add('is-visible');
    toast.dataset.timer = String(window.setTimeout(hide, 4000));
  };

  jobMenuButtons.forEach((button) => {
    if (button.dataset.bound === 'true') return;
    button.dataset.bound = 'true';

    button.addEventListener('click', () => {
      const rawUrl = button.dataset.jobUrl || '';
      const normalizedUrl = rawUrl.replace(/^~\//, '/').replace(/^~$/, '/');
      let url = window.location.href;
      if (normalizedUrl) {
        try {
          url = normalizedUrl.startsWith('http')
            ? normalizedUrl
            : new URL(normalizedUrl, window.location.origin).href;
        } catch {
          url = window.location.href;
        }
      }

      copyText(url).then((isCopied) => {
        if (!isCopied) {
          console.error('Kopyalama hatası: Clipboard API kullanılamadı.');
          return;
        }
        showCopyToast(button.dataset.copyToast, button.dataset.copyCloseLabel);
      }).catch((err) => {
        console.error('Kopyalama hatası:', err);
      });
    });
  });
};

export const initAppDownloadModal = () => {
  const appDownloadModalOverlay = document.getElementById('appDownloadModalOverlay');
  const appDownloadModalClose = document.getElementById('appDownloadModalClose');
  const applyButtons = document.querySelectorAll('.job-detail-apply-btn, a[href="#apply"], .btn[href="#apply"]');

  if (!appDownloadModalOverlay) return;

  const openAppDownloadModal = (event) => {
    event.preventDefault();
    appDownloadModalOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };

  const closeAppDownloadModal = () => {
    appDownloadModalOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  applyButtons.forEach((button) => {
    button.addEventListener('click', openAppDownloadModal);
  });

  if (appDownloadModalClose) {
    appDownloadModalClose.addEventListener('click', closeAppDownloadModal);
  }

  appDownloadModalOverlay.addEventListener('click', (event) => {
    if (event.target === appDownloadModalOverlay) {
      closeAppDownloadModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && appDownloadModalOverlay.classList.contains('is-open')) {
      closeAppDownloadModal();
    }
  });
};

export const initJobDetailBackButton = () => {
  const buttons = document.querySelectorAll('button.job-detail-back');
  if (!buttons.length) return;

  const fallbackUrl = document.body?.dataset?.jobsUrl
    || (document.documentElement.lang === 'en' ? '/en/jobs' : '/is-ilanlari');

  buttons.forEach((button) => {
    if (button.dataset.bound === 'true') return;
    if (button.closest('section.job-detail-section')) return;

    button.dataset.bound = 'true';
    button.addEventListener('click', (e) => {
      e.preventDefault();
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = fallbackUrl;
      }
    });
  });
};
